import { render, staticRenderFns } from "./UpdateNotesModal.vue?vue&type=template&id=7d95f9d4&"
import script from "./UpdateNotesModal.vue?vue&type=script&lang=js&"
export * from "./UpdateNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports